export default "__VITE_ASSET__MQVNAV$z__"